import Icon from 'components/shared/icon';
import ProgressBar from 'components/shared/progressBar';
import styles from './cartHeader.module.scss';

const CartHeader = ({ data, onClose }) => {
  const { colors, translations, progressModel } = data;

  return (
    <div className={styles.header}>
      <div className={styles.titleRow}>
        <h2 className={styles.title}>
          {translations?.cart?.title || translations?.accessibility?.cartDialog || ''}
        </h2>
        <button
          type="button"
          className={styles.closeBtn}
          onClick={onClose}
          aria-label={translations?.accessibility?.closeCart || 'Close cart'}
        >
          <Icon type="close" />
        </button>
      </div>
      {progressModel?.bar ? (
        <>
          {progressModel.label ? <p className={styles.label}>{progressModel.label}</p> : null}
          <ProgressBar color={colors?.shippingProgressBarColor} {...progressModel.bar} />
        </>
      ) : null}
    </div>
  );
};

export default CartHeader;
